import React from 'react'
import { useHistory } from 'react-router-dom'

import { Modal, theme } from '@acorns/web-components'
import { Button } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { ERROR_PAGE } from 'utils/testing/testIDs'

import { fonts } from '../styles'

const Container = styled.div`
  align-items: center;
  background-color: ${theme.colors.charcoal};
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`

const Title = styled.h2`
  ${fonts.AN_22_600_30};
  text-align: center;
`

export const Body = styled.p`
  ${fonts.AN_14_600_22};
  font-weight: 400;
  margin-bottom: 40px;
  margin-top: 20px;
  text-align: center;
`

export const StyledButton = styled(Button)`
  width: 100%;
`

const Error = (): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()
  const history = useHistory()

  const title = getRemoteString({ key: 'error.generic.title' })
  const body = getRemoteString({ key: 'error.generic.body' })
  const cta = getRemoteString({ key: 'error.generic.cta' })

  const handleClose = () => {
    history.goBack()
  }

  return (
    <Container data-testid={ERROR_PAGE}>
      <Modal isOpen onRequestClose={handleClose}>
        <Title>{title}</Title>
        <Body>{body}</Body>
        <StyledButton onPress={handleClose}>{cta}</StyledButton>
      </Modal>
    </Container>
  )
}

export { Error }
